export {default} from '../../../core/components/Repository/AttachmentUploadPopup';